import Accounts from './Accounting/Accounts';
import Contras from './Accounting/Contras';
import DeemedPayments from './Accounting/DeemedPayments';
import JournalEntries from './Accounting/JournalEntries';

import BankAccounts from './Bank/Accounts';
import BankReconciliationsManual from './Bank/BankReconciliationManual';
import BankReconciliationSmart from './Bank/BankReconciliationSmart';
import Incomes from './Bank/Incomes';
import Expenses from './Bank/Expenses';
import BankTransfers from './Bank/Transfers';

import Contacts from './Contacts/Contacts';
import ContactGroups from './Contacts/ContactGroups';
import ContactStatements from './Contacts/ContactStatements';

import Instructions from './ControlPanel/Instructions';
import ProductGroups from './Products/ProductGroups';
import Products from './Products/Products';
import StockAdjustments from './Products/StockAdjustments';
import StockTransfers from './Products/StockTransfers';

import Bills from './Purchases/Bills';
import PurchaseCreditNotes from './Purchases/CreditNotes';
import GoodsReceivedNotes from './Purchases/GoodsReceivedNotes';
import PurchaseOrders from './Purchases/Orders';
import PurchasePayments from './Purchases/Payments';
import PurchaseRefunds from './Purchases/Refunds';

import SaleCreditNotes from './Sales/CreditNotes';
import DeliveryOrders from './Sales/DeliveryOrders';
import Invoices from './Sales/Invoices';
import SaleOrders from './Sales/Orders';
import SalePayments from './Sales/Payments';
import Quotes from './Sales/Quotes';
import SaleRefunds from './Sales/Refunds';

// ------ Reports -------
// Financial Reports
import BalanceSheet from './Reports/Financial/BalanceSheet';
import ProfitLoss from './Reports/Financial/ProfitLoss';
import CashFlow from './Reports/Financial/CashFlow';
import FinancialSummary from './Reports/Financial/FinancialSummary';

// Aging Reports
import ReceivableDetails from './Reports/Aging/ReceivableDetails';
import PayableDetails from './Reports/Aging/PayableDetails';
import ReceivableSummary from './Reports/Aging/ReceivableSummary';
import PayableSummary from './Reports/Aging/PayableSummary';

// Sales Reports
import InvoiceSummary from './Reports/Sales/InvoiceSummary';
import CreditNoteSummary from './Reports/Sales/CreditNoteSummary';
import PaymentSummary from './Reports/Sales/PaymentSummary';
import QuotationByCustomer from './Reports/Sales/QuotationByCustomer';
import SalesOrderByCustomer from './Reports/Sales/SalesOrderByCustomer';
import DeliveryOrderByCustomer from './Reports/Sales/DeliveryOrderByCustomer';
import SalesByCustomer from './Reports/Sales/SalesByCustomer';
import SalesByTag from './Reports/Sales/SalesByTag';

// Purchase Reports
import BillSummary from './Reports/Purchases/BillSummary';
import BillCreditNoteSummary from './Reports/Purchases/CreditNoteSummary';
import PurchaseOrderBySupplier from './Reports/Purchases/PurchaseOrderBySupplier';
import BillPaymentSummary from './Reports/Purchases/PaymentSummary';

// Payment Reports
import OfficialReceiptSummary from './Reports/Payment/OfficialReceiptSummary';
import PaymentVoucherSummary from './Reports/Payment/PaymentVoucherSummary';
import CashSalesSummary from './Reports/Payment/CashSummary/CashSalesSummary';
import CashPurchaseSummary from './Reports/Payment/CashSummary/CashPurchaseSummary';

// Product Reports
import ProductSalesSummary from './Reports/Products/ProductSalesSummary';
import ProductSalesDetail from './Reports/Products/ProductSalesDetail';
import ProductBundleSalesSummary from './Reports/ProductBundles/ProductBundleSalesSummary';
import ProductPurchaseSummary from './Reports/Products/ProductPurchaseSummary';
import ProductPurchaseDetail from './Reports/Products/ProductPurchaseDetail';
import ItemSalesCollection from './Reports/Products/ItemSalesCollection';

// Inventory Reports
import InventorySummary from './Reports/Inventory/InventorySummary';
import InventoryDetail from './Reports/Inventory/InventoryDetail';
import InventorySummaryByLocation from './Reports/Inventory/InventorySummaryByLocation';
import ProfitSummary from './Reports/ProfitSummary/ProfitSummary';
import ProfitDetail from './Reports/ProfitDetail/ProfitDetail';

// Fixed Asset Reports
import FixedAssets from './Reports/FixedAssets/FixedAssets';
import DepreciationSchedule from './Reports/FixedAssets/DepreciationSchedule';
import DisposalSchedule from './Reports/FixedAssets/DisposalSchedule';

// Ledger Reports
import GeneralLedger from './Reports/Ledgers/GeneralLedger';
import DebtorLedger from './Reports/Ledgers/DebtorLedger';
import CreditorLedger from './Reports/Ledgers/CreditorLedger';

// SST Reports
import Sst02 from './Reports/SST/Sst02';
import SstSalesDetail from './Reports/SST/SstSalesDetail';
import SstPurchaseDetail from './Reports/SST/SstPurchaseDetail';
import SstPaymentCollection from './Reports/SST/SstPaymentCollection';
import SstDeemedPayments from './Reports/SST/SstDeemedPayments';
import SstRecoveredPayments from './Reports/SST/SstRecoveredPayments';
import SstPastPrepayments from './Reports/SST/SstPastPrepayments';
import SstCurrentPrepayments from './Reports/SST/SstCurrentPrepayments';
import SstByProducts from './Reports/SST/SstByProducts';

// Accounting Reports
import JournalEntryDetail from './Reports/Accounting/JournalEntryDetail';
import DoubleEntryDetail from './Reports/Accounting/DoubleEntryDetail';
import TrialBalance from './Reports/Accounting/TrialBalance';
import ReportBankReconciliation from './Reports/BankReconciliation/BankReconciliation';
import ReportReconciledTransactions from './Reports/BankReconciliation/ReconciledTransactions';
import TransactionList from './Reports/Accounting/TransactionList';
import ForeignExchangeSummary from './Reports/Accounting/ForeignExchangeSummary';
// import ForeignExchangeDetail from './Reports/Accounting/ForeignExchangeDetail';
import UnrealisedExchangeDetail from './Reports/Accounting/UnrealisedExchangeDetail';
import ExchangeRate from './Reports/Accounting/ExchangeRate';
import AuditTrail from './Reports/Accounting/AuditTrail';
import ChartOfAccounts from './Reports/Accounting/ChartOfAccounts';
import BankFeedTransactions from './Bank/BankFeedTransactions';
import PurchasesBySupplier from './Reports/Sales/PurchasesBySupplier';

//Bukku Admin
import TransactionRecord from './BukkuAdmin/TransactionRecord';
import { StorageKey } from '../../enums/StorageKey';
import StockValues from './Stock/StockValues';

export const Columns = {
    // Transaction
    [Contras.storageKey]: Contras,
    [DeemedPayments.storageKey]: DeemedPayments,
    [JournalEntries.storageKey]: JournalEntries,

    [Incomes.storageKey]: Incomes,
    [Expenses.storageKey]: Expenses,
    [BankTransfers.storageKey]: BankTransfers,

    [StockAdjustments.storageKey]: StockAdjustments,
    [StockTransfers.storageKey]: StockTransfers,

    [Bills.storageKey]: Bills,
    [PurchaseCreditNotes.storageKey]: PurchaseCreditNotes,
    [GoodsReceivedNotes.storageKey]: GoodsReceivedNotes,
    [PurchaseOrders.storageKey]: PurchaseOrders,
    [PurchasePayments.storageKey]: PurchasePayments,
    [PurchaseRefunds.storageKey]: PurchaseRefunds,

    [SaleCreditNotes.storageKey]: SaleCreditNotes,
    [DeliveryOrders.storageKey]: DeliveryOrders,
    [Invoices.storageKey]: Invoices,
    [SaleOrders.storageKey]: SaleOrders,
    [SalePayments.storageKey]: SalePayments,
    [Quotes.storageKey]: Quotes,
    [SaleRefunds.storageKey]: SaleRefunds,

    // Others
    [Accounts.storageKey]: Accounts,
    [BankAccounts.storageKey]: BankAccounts,
    [BankFeedTransactions.storageKey]: BankFeedTransactions,
    [BankReconciliationsManual.storageKey]: BankReconciliationsManual,
    [BankReconciliationSmart.storageKey]: BankReconciliationSmart,
    [Contacts.storageKey]: Contacts,
    [ContactGroups.storageKey]: ContactGroups,
    [ContactStatements.storageKey]: ContactStatements,
    [Instructions.storageKey]: Instructions,
    [ProductGroups.storageKey]: ProductGroups,
    [Products.storageKey]: Products,

    //  ---------- REPORTS -----------
    // Financial Reports
    [BalanceSheet.storageKey]: BalanceSheet,
    [ProfitLoss.storageKey]: ProfitLoss,
    [CashFlow.storageKey]: CashFlow,
    [FinancialSummary.storageKey]: FinancialSummary,

    // Aging Reports
    [ReceivableSummary.storageKey]: ReceivableSummary,
    [ReceivableDetails.storageKey]: ReceivableDetails,
    [PayableSummary.storageKey]: PayableSummary,
    [PayableDetails.storageKey]: PayableDetails,

    // Sales Reports
    [InvoiceSummary.storageKey]: InvoiceSummary,
    [CreditNoteSummary.storageKey]: CreditNoteSummary,
    [PaymentSummary.storageKey]: PaymentSummary,
    [QuotationByCustomer.storageKey]: QuotationByCustomer,
    [SalesOrderByCustomer.storageKey]: SalesOrderByCustomer,
    [DeliveryOrderByCustomer.storageKey]: DeliveryOrderByCustomer,
    [SalesByCustomer.storageKey]: SalesByCustomer,
    [SalesByTag.storageKey]: SalesByTag,

    // Purchase Reports
    [BillSummary.storageKey]: BillSummary,
    [BillCreditNoteSummary.storageKey]: BillCreditNoteSummary,
    [BillPaymentSummary.storageKey]: BillPaymentSummary,
    [PurchaseOrderBySupplier.storageKey]: PurchaseOrderBySupplier,
    [PurchasesBySupplier.storageKey]: PurchasesBySupplier,

    // Payment Reports
    [OfficialReceiptSummary.storageKey]: OfficialReceiptSummary,
    [PaymentVoucherSummary.storageKey]: PaymentVoucherSummary,
    [CashSalesSummary.storageKey]: CashSalesSummary,
    [CashPurchaseSummary.storageKey]: CashPurchaseSummary,

    // Product Reports
    [ProductSalesSummary.storageKey]: ProductSalesSummary,
    [ProductSalesDetail.storageKey]: ProductSalesDetail,
    [ProductBundleSalesSummary.storageKey]: ProductBundleSalesSummary,
    [ProductPurchaseSummary.storageKey]: ProductPurchaseSummary,
    [ProductPurchaseDetail.storageKey]: ProductPurchaseDetail,
    [ItemSalesCollection.storageKey]: ItemSalesCollection,

    // Inventory Reports
    [InventorySummary.storageKey]: InventorySummary,
    [InventoryDetail.storageKey]: InventoryDetail,
    [InventorySummaryByLocation.storageKey]: InventorySummaryByLocation,
    [ProfitSummary.storageKey]: ProfitSummary,
    [ProfitDetail.storageKey]: ProfitDetail,

    // Fixed Asset Reports
    [FixedAssets.storageKey]: FixedAssets,
    [DepreciationSchedule.storageKey]: DepreciationSchedule,
    [DisposalSchedule.storageKey]: DisposalSchedule,

    // Ledger Reports
    [GeneralLedger.storageKey]: GeneralLedger,
    [DebtorLedger.storageKey]: DebtorLedger,
    [CreditorLedger.storageKey]: CreditorLedger,

    // SST Reports
    [Sst02.storageKey]: Sst02,
    [SstSalesDetail.storageKey]: SstSalesDetail,
    [SstPurchaseDetail.storageKey]: SstPurchaseDetail,
    [SstPaymentCollection.storageKey]: SstPaymentCollection,
    [SstDeemedPayments.storageKey]: SstDeemedPayments,
    [SstRecoveredPayments.storageKey]: SstRecoveredPayments,
    [SstPastPrepayments.storageKey]: SstPastPrepayments,
    [SstCurrentPrepayments.storageKey]: SstCurrentPrepayments,
    [SstByProducts.storageKey]: SstByProducts,

    // Accounting Reports
    [JournalEntryDetail.storageKey]: JournalEntryDetail,
    [DoubleEntryDetail.storageKey]: DoubleEntryDetail,
    [TrialBalance.storageKey]: TrialBalance,
    [ReportBankReconciliation.storageKey]: ReportBankReconciliation,
    [ReportReconciledTransactions.storageKey]: ReportReconciledTransactions,
    [TransactionList.storageKey]: TransactionList,
    [ForeignExchangeSummary.storageKey]: ForeignExchangeSummary,
    // [ForeignExchangeDetail.storageKey]: ForeignExchangeDetail,
    [UnrealisedExchangeDetail.storageKey]: UnrealisedExchangeDetail,
    [ExchangeRate.storageKey]: ExchangeRate,
    [AuditTrail.storageKey]: AuditTrail,
    [ChartOfAccounts.storageKey]: ChartOfAccounts,

    //Bukku Admin
    [TransactionRecord.storageKey]: TransactionRecord,

    // Stocks
    [StorageKey.stock_values]: StockValues,
};
